<template>
    <div class="top px-4">
        <Template-breadcrumb></Template-breadcrumb>

        <div class="row">
            <div class="col-md-6 d-md-flex align-items-baseline">
                <h1 class="mr-2">List of {{ properNaming }} Templates</h1>
            </div>
            <!-- SEARCH FUNCTION HERE -->
            <div class="col-md-6 pb-3">
                <input-search-icon
                    v-model="query"
                    :settingTemplate="true"
                    @search="searchSettingTemplate"
                >
                    <template v-slot:before>
                        <filter-template-type
                            :filterType="templateType"
                            @selected="changeFilterType"
                        />
                    </template>
                </input-search-icon>
            </div>
        </div>
        <b-card footer-class="p-0" class="rounded-lg">
            <div class="table-holder table-responsive">
                <LoaderList v-if="isLoading" class="w-100" />
                <b-table-simple v-else borderless hover class="list">
                    <thead>
                        <tr>
                            <th style="min-width: 100px;">
                                <sorting
                                    :order-by="
                                        meta && meta.order == 'name'
                                            ? meta.orderBy
                                            : null
                                    "
                                    @sorting="
                                        orderBy =>
                                            getList(
                                                meta.currentPage,
                                                orderBy,
                                                'name'
                                            )
                                    "
                                    text="Name:"
                                >
                                </sorting>
                            </th>
                            <th class="text-nowrap">
                                Type:
                            </th>
                            <th class="text-nowrap" style="min-width: 200px;">
                                Description:
                            </th>
                            <th class="text-nowrap">
                                <sorting
                                    :order-by="
                                        meta && meta.order == 'update_at'
                                            ? meta.orderBy
                                            : null
                                    "
                                    @sorting="
                                        orderBy =>
                                            getList(
                                                meta.currentPage,
                                                orderBy,
                                                'update_at'
                                            )
                                    "
                                    text="Last Updated:"
                                >
                                </sorting>
                            </th>
                            <th class="text-nowrap">
                                <sorting
                                    :order-by="
                                        meta && meta.order == 'create_by'
                                            ? meta.orderBy
                                            : null
                                    "
                                    @sorting="
                                        orderBy =>
                                            getList(
                                                meta.currentPage,
                                                orderBy,
                                                'create_by'
                                            )
                                    "
                                    text="Created By:"
                                >
                                </sorting>
                            </th>
                            <th class="text-nowrap">
                                <sorting
                                    :order-by="
                                        meta && meta.order == 'last_used'
                                            ? meta.orderBy
                                            : null
                                    "
                                    @sorting="
                                        orderBy =>
                                            getList(
                                                meta.currentPage,
                                                orderBy,
                                                'last_used'
                                            )
                                    "
                                    text="Last Used:"
                                >
                                </sorting>
                            </th>
                            <th class=""></th>
                        </tr>
                    </thead>
                    <tbody v-if="settingTemplates.length == 0">
                        <tr>
                            <td colspan="7"><i>No records available</i></td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(temp, i) in settingTemplates" :key="i">
                            <td>
                                <TemplateLink :temp="temp" />
                            </td>
                            <td>
                                {{
                                    temp.template_type
                                        ? temp.template_type.value
                                        : ""
                                }}
                            </td>
                            <td
                                v-if="
                                    temp.type == TEMPLATES.TYPE.CONTENT_SNIPPET
                                "
                            >
                                <div>{{ temp.description }}</div>
                                <div>
                                    <span class="font-weight-bold"
                                        >Hashtag:</span
                                    >
                                    {{ temp.hashtag }}
                                </div>
                            </td>
                            <td
                                v-else-if="
                                    temp.type == TEMPLATES.TYPE.CUSTOM_FIELD
                                "
                            >
                                <div>
                                    <span class="font-weight-bold"
                                        >Values:</span
                                    >
                                    {{ temp.custom_field_values }}
                                </div>
                                <div>
                                    <span class="font-weight-bold"
                                        >Included In:</span
                                    >
                                    {{ temp.custom_field_include_in }}
                                </div>
                            </td>
                            <td v-else>
                                {{ temp.description }}
                            </td>
                            <td class="text-nowrap">
                                <span>
                                    {{ _carbonDateDisplay(temp.update_at) }}
                                </span>
                            </td>
                            <td class="text-nowrap">
                                <span>
                                    {{
                                        temp.create_by
                                            ? temp.create_by.label
                                            : null
                                    }}
                                </span>
                            </td>
                            <td class="text-nowrap">
                                <span>
                                    {{ convertToDateFormat(temp.last_used) }}
                                </span>
                            </td>
                            <td class="text-right small text-nowrap">
                                <span
                                    v-if="temp.encoded_id && temp.isCanEdit"
                                    class="cursor-pointer"
                                >
                                    <router-link
                                        style="all: unset;"
                                        v-if="temp.isUsingView"
                                        :to="{
                                            name: 'template_details',
                                            params: {
                                                type:
                                                    TEMPLATES.LIST[temp.type]
                                                        .route,
                                                id: temp.encoded_id
                                            }
                                        }"
                                    >
                                        Edit
                                    </router-link>
                                    <span
                                        v-else-if="temp.isEditByModal"
                                        @click="openModalEdit(temp)"
                                        class="cursor-pointer"
                                    >
                                        Edit
                                    </span>
                                    <a
                                        style="all: unset;"
                                        v-else
                                        :href="`${env.APPS}business/template/view/${temp.encoded_id}`"
                                    >
                                        Edit
                                    </a>
                                </span>
                                <span
                                    v-if="
                                        temp.isCanEdit &&
                                        (temp.isCanDuplicate ||
                                            temp.isCanDelete)
                                    "
                                >
                                    |
                                </span>
                                <span
                                    v-if="temp.isCanDuplicate"
                                    @click="duplicateSettingTemplate(temp)"
                                    class="cursor-pointer text-nowrap"
                                >
                                    Duplicate
                                </span>
                                <span
                                    v-if="
                                        temp.isCanDuplicate && temp.isCanDelete
                                    "
                                >
                                    |
                                </span>
                                <span
                                    v-if="temp.isCanDelete"
                                    @click="deleteSettingTemplate(temp)"
                                    class="cursor-pointer"
                                >
                                    Delete
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </b-table-simple>

                <div class="text-right w-100 p-3">
                    <b-pagination
                        v-if="meta && !isLoading"
                        v-show="meta.lastPage > 1"
                        class="vet-pagination mt-0 mb-0"
                        align="right"
                        v-model="meta.currentPage"
                        :total-rows="meta.total"
                        :per-page="meta.perPage"
                        prev-text="Prev"
                        next-text="Next"
                        first-text="Start"
                        last-text="Last"
                        @change="getList"
                    />
                </div>
            </div>
        </b-card>
        <modal-delete-template ref="modalDeleteTemplate" @onsuccess="getList" />
        <modal-duplicate-template ref="modalDuplicateTemplate" />
    </div>
</template>

<script>
import { DateTime } from "luxon";
import { debounce, find, findKey } from "lodash";
import TEMPLATES from "@/constants/templates";
import TemplateService from "@/services/templates";

const TEMPLATE_CANNOT_DUPLICATED = [
    TEMPLATES.TYPE.CUSTOM_FIELD,
    TEMPLATES.TYPE.ATTACHMENT
];

const TEMPLATES_EDIT_MODAL = [
    TEMPLATES.TYPE.ATTACHMENT,
    TEMPLATES.TYPE.CUSTOM_FIELD
];

export default {
    components: {
        TemplateBreadcrumb: () =>
            import("@/module/settings/template/breadcrumb.vue"),
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        Sorting: () => import("@/module/commons/sorting.vue"),
        inputSearchIcon: () => import("@/module/commons/input-search-icon.vue"),
        TemplateLink: () => import("@/components/commons/template-link"),
        ModalDeleteTemplate: () =>
            import("@/components/setting-template/modal-delete-template"),
        FilterTemplateType: () =>
            import("@/components/setting-template/filter-template-type.vue"),
        ModalDuplicateTemplate: () =>
            import("@/components/setting-template/modal-duplicate-template")
    },
    props: {
        templateType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            TEMPLATES,
            query: null,
            settingTemplates: [],
            meta: null,
            isLoading: false
        };
    },
    watch: {
        templateType() {
            this.getList(1, "asc", "name");
            this.dynamicPageTitle(`${this.properNaming} Templates`);
        }
    },
    computed: {
        properNaming() {
            let templateType = find(TEMPLATES.LIST, {
                route: String(this.templateType)
            });

            return templateType.label;
        }
    },
    mounted() {
        this.getList(1, "asc", "name");
        this.dynamicPageTitle(`${this.properNaming} Templates`);
    },
    beforeDestroy() {},
    methods: {
        async getList(page = 1, orderBy, order) {
            const templateTypeId = parseInt(
                findKey(TEMPLATES.LIST, { route: this.templateType })
            );
            try {
                this.isLoading = true;

                const orderParam = order ? order : this.meta?.order ?? "name";
                const orderByParam = orderBy
                    ? orderBy
                    : this.meta?.orderBy ?? "asc";

                let params = {
                    query: this.query,
                    page: page,
                    perPage: this.PER_PAGE,
                    orderBy: orderByParam,
                    order: orderParam,
                    type: templateTypeId
                };

                let response = await TemplateService.getTemplates(params);

                if (response) {
                    this.settingTemplates = response.resources.map(template => {
                        // Refer to application/views/staff/business/sub/template/list.php
                        let isCanEdit = true,
                            isCanDelete = true;
                        if (
                            template.type === TEMPLATES.TYPE.WELLNESS_PLAN &&
                            template.wellnessPlanTemplateActivePatient > 0
                        ) {
                            isCanEdit = false;
                            isCanDelete = false;
                        }

                        template.isCanDelete = isCanDelete;
                        template.isCanEdit = isCanEdit;
                        template.isCanDuplicate = !TEMPLATE_CANNOT_DUPLICATED.includes(
                            template.type
                        );
                        template.isUsingView = TEMPLATES.IN_VIEW.includes(
                            template.type
                        );
                        template.isEditByModal = TEMPLATES_EDIT_MODAL.includes(
                            template.type
                        );
                        return template;
                    });
                    this.meta = response.meta;
                    this.meta.orderBy = orderByParam;
                    this.meta.order = orderParam;
                    this.isLoading = false;
                } else {
                    throw "Error";
                }
            } catch (error) {
                console.error(error);
                this._message("Cannot retrieve template list", "danger");
                this.isLoading = false;
            }
        },
        searchSettingTemplate(keyword) {
            this.query = keyword;
            this.debounceSearchSettingTemplate(keyword, this);
        },
        debounceSearchSettingTemplate: debounce(async (search, self) => {
            self.getList(1);
        }, 350),
        duplicateSettingTemplate(template) {
            this.$refs.modalDuplicateTemplate.open({
                templateId: template.id,
                templateName: template.name,
                templateType: template.type,
                templateDescription: template.description
            });
        },
        deleteSettingTemplate(template) {
            this.$refs.modalDeleteTemplate.open(template);
        },
        convertToDateFormat(epochTimestamp) {
            if (!epochTimestamp) {
                return "";
            }

            // Convert epoch timestamp in seconds to milliseconds for Luxon
            const dateTime = DateTime.fromMillis(epochTimestamp * 1000);

            // Format the date as desired, e.g., "yyyy-MM-dd"
            return dateTime.toFormat(this._dateFormat);
        },
        changeFilterType(type) {
            if (type === this.templateType) {
                return;
            }

            this.query = null;

            this.$router.push(`/settings/template/${type}`);
        },
        openModalEdit(temp) {
            this.$emit("edit-dialog", temp);
        }
    }
};
</script>
<style scoped>
.top {
    margin-top: 10px;
    margin-bottom: 3px;
}
</style>
